// extracted by mini-css-extract-plugin
export default {"layout__register":"layout_layout__register__6bLFk","layout__login":"layout_layout__login__jlnH5"};